import * as THREE from "three";
import type { ClubMaterials } from "../materials";
import { buildIsland } from "./island";
import { buildDocks } from "./docks";
import { buildClubhouse } from "./clubhouse";
import { plantPalms } from "./vegetation";
import { buildScenery } from "./scenery";

export function buildMarina(mats: ClubMaterials): THREE.Group {
  const g = new THREE.Group();
  g.name = "marina";
  g.add(buildIsland(mats));
  g.add(buildDocks(mats));
  g.add(buildClubhouse(mats));
  g.add(plantPalms(mats));
  g.add(buildScenery(mats));
  return g;
}
